import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../data/translations';
import { HumanityIcon, NeutralityIcon, AccountabilityIcon, IntegrityIcon, ParticipationIcon } from './Icons';
import './Values.css';

const Values = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const values = [
    {
      title: t.humanity,
      description: t.humanityDesc,
      Icon: HumanityIcon
    },
    {
      title: t.neutralityImpartiality,
      description: t.neutralityDesc,
      Icon: NeutralityIcon
    },
    {
      title: t.accountability,
      description: t.accountabilityDesc,
      Icon: AccountabilityIcon
    },
    {
      title: t.integrity,
      description: t.integrityDesc,
      Icon: IntegrityIcon
    },
    {
      title: t.participation,
      description: t.participationDesc,
      Icon: ParticipationIcon
    }
  ];

  return (
    <section id="values" className="values">
      <div className="container">
        <div className="section-header">
          <h2>{t.coreValues}</h2>
          <p>{t.valuesIntro}</p>
        </div>
        
        <div className="values-grid">
          {values.map((value, index) => (
            <div key={index} className="value-card">
              <div className="value-icon">
                <value.Icon />
              </div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Values;
